import { scrollTo } from 'dpl/shared/utils';

export function isBackForwardNavigation() {
  try {
    return (
      performance.getEntriesByType('navigation')[0].type === 'back_forward'
    );
  } catch (e) {
    return false;
  }
}

export function persistInfiniteScrollDataToHistory(queries) {
  const queriesData = Object.entries(queries).reduce(
    (c, [queryKey, queryValue]) => {
      if (!queryValue.isSuccess) {
        return c;
      }

      return {
        ...c,
        // TODO: instead of serializing, set response objects to empty obj
        [queryKey]: JSON.stringify(queryValue.data)
      };
    },
    {}
  );

  window.history.replaceState(
    {
      queriesData,
      scrollPosition: window.scrollY
    },
    ''
  );
}

export function getQueryDataFromHistory(queryName) {
  if (isBackForwardNavigation()) {
    try {
      return JSON.parse(window.history.state?.queriesData[queryName]);
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  return undefined;
}

export function restoreScrollPositionFromHistory() {
  if (window.history.state?.scrollPosition && isBackForwardNavigation()) {
    scrollTo({ top: window.history.state.scrollPosition });
  }
}
